import {MoneyInput} from '@frontend/components/inputs/MoneyInput'
import {trans} from '@frontend/helpers'
import {useRegionConfig} from '@frontend/hooks'
import {FilterLabel} from './FilterLabel'

interface Props {
    minPrice: number | null
    maxPrice: number | null
    setMinPrice: (value: number | null) => void
    setMaxPrice: (value: number | null) => void
    disabled?: boolean
    noLabel?: boolean
}

// Фильтр по цене.
export function PriceFilter(props: Props) {

    const regionConfig = useRegionConfig()

    const {
        minPrice,
        maxPrice,
        setMinPrice,
        setMaxPrice,
        disabled,
        noLabel,
    } = props

    return (
        <div className="pb-4">
            {!noLabel && (
                <FilterLabel
                    label={trans().ads.list.filters.price}
                    showResetButton={minPrice !== null || maxPrice !== null}
                    disabled={disabled}
                    onReset={() => {
                        setMinPrice(null)
                        setMaxPrice(null)
                    }}
                />
            )}
            <div className="d-grid grid-columns-2 gap-small">
                <MoneyInput
                    label={trans().ads.list.filters.price_from}
                    value={String(minPrice ?? '')}
                    maxLength={regionConfig.adPrice.maxDigits}
                    numeralFormat={regionConfig.moneyInput.numeralFormatForPriceFilter}
                    className="borderless"
                    wrapperClassName="m-0"
                    disabled={disabled}
                    onChange={(_e, _formattedValue, cleanValue) => {
                        setMinPrice(cleanValue)
                    }}
                />
                <MoneyInput
                    label={trans().ads.list.filters.price_to}
                    value={String(maxPrice ?? '')}
                    maxLength={regionConfig.adPrice.maxDigits}
                    numeralFormat={regionConfig.moneyInput.numeralFormatForPriceFilter}
                    className="borderless"
                    wrapperClassName="m-0"
                    disabled={disabled}
                    onChange={(_e, _formattedValue, cleanValue) => {
                        setMaxPrice(cleanValue)
                    }}
                />
            </div>
        </div>
    )
}
